import * as MediaFragment from "utils/MediaFragment";

const mediaFragmentDictionary = {
  [MediaFragment.AUDIO]: "MP4/audio.mp4",
  [MediaFragment.DASH_LEGACY]: "MPD/Desktop-Dash.mpd",
  [MediaFragment.HLS_LOOP_LEGACY]: "HLS/Desktop-HLS.m3u8",
  [MediaFragment.HLS_DESKTOP_LEGACY]: "HLS/Mobile-HLS.m3u8",
  [MediaFragment.MP4_HIGH]: "MP4/720-2396.mp4",
  [MediaFragment.MP4_LOW]: "MP4/360-730.mp4",
  [MediaFragment.MP4_MEDIUM]: "MP4/540-1092.mp4",
  [MediaFragment.MP4_VERY_HIGH]: "MP4/1080-3626.mp4",
  [MediaFragment.SILENT_AUDIO]: "/av/custom_media/blankaudio_1sec.mp4",
  [MediaFragment.HLS]: "HLS/HEVC-HLS.m3u8",
  [MediaFragment.DASH]: "MPD/VP9-Dash.mpd",
  [MediaFragment.DASH_FALLBACK]: "MPD/H264-Dash.mpd",
};

const manifestSlugDictionary = {
  [MediaFragment.DASH_LEGACY]: "desktop-dash",
  [MediaFragment.HLS_LOOP_LEGACY]: "desktop-hls",
  [MediaFragment.HLS_DESKTOP_LEGACY]: "mobile-hls",
  [MediaFragment.HLS]: "hevc-hls",
  [MediaFragment.DASH]: "vp9-dash",
  [MediaFragment.DASH_FALLBACK]: "h264-dash",
};

export function hasManifestForMediaFragment(manifestTypes, mediaFragment) {
  if (!manifestSlugDictionary[mediaFragment]) {
    throw new Error(
      `Programming error: no type found for ${mediaFragment} in dictionary`,
    );
  }
  return (
    manifestTypes.findIndex((manifest) =>
      manifest.toLowerCase().includes(manifestSlugDictionary[mediaFragment]),
    ) >= 0
  );
}

export default function composeMediaFragment(
  videoRoot,
  mediaFragment,
  customHost = null,
) {
  if (mediaFragment === MediaFragment.SILENT_AUDIO) {
    return mediaFragmentDictionary[MediaFragment.SILENT_AUDIO];
  }

  //use dicionary or compose it
  const fragment =
    mediaFragmentDictionary[mediaFragment] || `MP4/${mediaFragment}.mp4`;
  const normalizedHost = customHost || "/av";
  return `${normalizedHost}/${videoRoot}/${fragment}`;
}
